import { App, Plugin } from 'vue';
import { Trans } from 'www-shared';

const i18n: Plugin = {
  install: (app: App): void => {
    // eslint-disable-next-line no-param-reassign
    app.config.globalProperties.$t = (en: string, key: string, label?: string) => {
      if (label) return label;
      return Trans.by(en, key);
    };
  },
};

declare module '@vue/runtime-core' {
  // Bind to `this` keyword
  interface ComponentCustomProperties {
    $t: (en: string, key: string, label?: string) => string;
  }
}
export default i18n;
